import React from "react";
import backgroundImage from "../../../assets/images/main_background.png";
import contactUs from "../../../assets/images/contact_us.png";
import conversation from "../../../assets/images/conversation.png";
import justice from "../../../assets/images/justice.png";
import privacy from "../../../assets/images/privacy.png";
import gift from "../../../assets/images/img_gift.png";
import Grid from "@material-ui/core/Grid";
import UserDetail from '../../pageComponents/Settings/UserDetail'
import Item from "../../pageComponents/Settings/Item";
import ExitButton from "../../pageComponents/Settings/ExitButton";
import RedBtn from "../../../assets/images/btn_red_bg.png";
import Toolbar from "../../Toolbar";
import {withRouter} from "react-router-dom";
import {withRouter as WR} from "react-router";
import {connect} from "react-redux";
import {data} from "../../../Store/Actions/DataAction";
import {questionNumber} from "../../../Store/Actions/QuestionNumberAction";
import {settings} from "../../../Store/Actions/SettingsAction";
import {SETTINGS_FAQ, SILVERUP} from "../../../Store/Actions/Types"
import axios from "axios";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
import {userData} from "../../../Utility/Url";
import Axios from '../../../Plugins/Axios'

const Ax=new Axios()
class SettingIndex extends React.Component {
    constructor() {
        super()
        this.state= {
            appHasLoaded: false,
            allDataLoaded:false,
            infoSectionOpacity:'1',
            style: {
                completed: 5,
                root: {
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor: "#810777",
                    height: '100%',
                    overflow: 'hidden',
                    backgroundBlendMode:'soft-light',
                    flex:1,
                    minHeight:'0'
                },
            }
        }
    }
    fetchData= async()=>{
        await axios.get(userData)
            .then(res => {
                const {data}=res
                this.setState({
                    allDataLoaded:true
                })
                this.props.data(data)
                // this.props.UserData.userData.properties.silver+=10
                // var someProperty = {...data}
                // someProperty.properties.silver+=10
                // this.props.data({someProperty})

            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    toggleIndexNav=(data)=>{
        switch (data) {
            case 'open':
                this.props.toggleBottomNavbar(false)
                this.setState({
                    infoSectionOpacity:'0',
                })
                break
            case 'close':
                this.props.toggleBottomNavbar(true)
                this.setState({
                    infoSectionOpacity:'1',
                })
                break
            default:
                this.props.toggleBottomNavbar(true)
                this.setState({
                    infoSectionOpacity:'1',
                })
        }
    }
    async componentDidMount() {
        this.props.toggleBottomNavbar(true)
        await this.fetchData()
        window.onpopstate = function(event) {
            console.log(window.history)
        };
    }
    onLeave(nextState) {
        if (nextState.action === 'POP') {
            console.log('Back Button Clicked ')
        }
    }
    render() {
        const items= [
            {
                id:'contactUs',
                text:'ارتباط با ما',
                icon:contactUs,
                textColor:'#ffffff',
                onClick:'contactUs'
            },
            {
                id:'faq',
                text:'سوالات متداول',
                icon:conversation,
                textColor:'#ffffff',
                onClick:'faq'
            },
            {
                id:'rules',
                text:'قوانین',
                icon:justice,
                textColor:'#ffffff',
                onClick:'rule'
            },
            {
                id:'privacy',
                text:'حریم خصوصی',
                icon:privacy,
                textColor:'#ffffff',
                onClick:'privacy'
            },
            {
                id:'free',
                text:'رایگان',
                icon:gift,
                bgColor:'rgba(222, 186, 33, 1)',

                textColor:'red',
                onClick:'/free'
            },
        ]
        const ExitButtonData={
            image:RedBtn,
            text:'خروج از حساب'
        }
        const {infoSectionOpacity,allDataLoaded}=this.state
        const data=this.props.UserData.userData
        let guest =false
        if (data)
            guest=data.userInfo.mobile===''
        return(
            <Grid direction={"column"} item container style={this.state.style.root}>
                {
                    allDataLoaded&&
                <Grid item sm={12} xs={12} direction={"column"} justify={'center'} container
                      style={{flex:'1',minHeight:'0'}}>
                    <Grid item container>
                        <Toolbar type='sideToolbar'/>
                    </Grid>
                    <Grid container xs={12} justify={"center"} alignItems={'flex-start'} alignContent={"flex-start"} sm={12} className='setting-menu scrollBar'
                          style={{flex:'1',minHeight:'0',overflow:'auto'}}>
                        <Grid item sm={10} xs={10} justify={'center'} container style={{opacity:infoSectionOpacity}}>
                            <UserDetail/>
                        </Grid>
                        <Grid className='setting-menu-items' item container alignItems={"flex-start"} justify={"center"}>
                            {items.map(data=>{
                                return <Grid className='setting-menu-item' id ='TT' item  sm={9} xs={9} style={{marginTop:'',marginBottom:''}}
                                             onClick={()=>{
                                                 if (data.onClick=='/free'){
                                                     this.props.history.push(data.onClick)
                                                 }
                                                 // this.loadData(data.onClick)
                                             }}
                                >
                                    <Item data={data} fullHeight={true} toggleIndexNav={this.toggleIndexNav} />
                                </Grid>})}
                            <Grid item
                                  className={"setting-menu-item " + (!guest ? 'clickable' : '')}
                                  sm={5} xs={5} justify={'center'} container
                                  style={{marginTop:'',marginBottom:'',opacity:guest?'0.5':'1'}}
                                onClick={()=>{
                                    if (!guest)
                                    Ax.logOut()
                                }}
                            >
                                <ExitButton data={ExitButtonData}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    }
                    {
                        !allDataLoaded &&
                        <p>Loading</p>
                    }
                        </Grid>
                }
                {
                !allDataLoaded &&
                <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                      style={{position:'relative',
                          top:'50%',left:'50%',transform:'translate(-50%,-50%)'}}
                >
                    <Grid item container justify={"center"} style={{position:'absolute',
                    }}>
                        <PicoLoader/>
                    </Grid>
                </Grid>
            }
                </Grid>
        )
    }
}
const Settings=withRouter (SettingIndex)

const mapStateToProps=state=>({
    UserData:state.UserData,
    Settings:state.Settings,
    QuestionNumber:state.QuestionNumber,
})
export default connect(mapStateToProps,{data,settings,questionNumber}) (Settings)
